// Минусът от продажби, както го вижда операторът. Наличността НИКОГА не се
// показва под 0 (на рафта не може да има под нулата) — до нулата стои червен
// маркер „−10 продадени без наличност". Знаковото число идва от BE (`/stock`,
// складовата карта); правилото кога следващият приход покрива минуса и кога
// го отписва е само в BE (`stock_balance_rules.py`).

// Под тази граница остатъкът е шум от закръглянето (количествата са с 4 знака)
const NEGATIVE_EPSILON = 0.0005;

// Показваната наличност: под нулата е 0
export const shownStock = (quantity: number) => (quantity > 0 ? quantity : 0);

// Колко е продадено/изписано без наличност (положително число; 0 — няма минус)
export const soldWithoutStockOf = (quantity: number) =>
  quantity < -NEGATIVE_EPSILON ? -quantity : 0;
